const role = {
    administrator: 1,      
    contentCreator: 3,  
    departmentHead: 2,  
    TerminalAdmin: 4, 
    superCityAdmin: 6
};

module.exports = { role };